/**
 * Description: Menu list data to be used for rendering side bar
 * Author: Trushita
 * From scratch
 */
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SettingsIcon from "@mui/icons-material/Settings";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import DashboardIcon from "@mui/icons-material/Dashboard";

// Generic menu that is used to rend the side bar
export const menu = [
  {
    name: "General Info",
    link: "/home",
    icon: <AccountCircleIcon />,
  },
  {
    name: "Subscription",
    link: "/subscription",
    icon: <LibraryBooksIcon />,
  },

  {
    name: "Settings",
    link: "/settings",
    icon: <SettingsIcon />,
  },
  {
    name: "Background Status",
    link: "/background-check",
    icon: <HowToRegIcon />,
  },
  {
    name: "My Dashboard",
    link: "/dashboard",
    icon: <DashboardIcon />,
  },
];
